import { useContext } from "react";
import { AppContext } from "../App";
import { hospitalInfo } from "../content/hospitalContent";
import { 
  IoLocationOutline, 
  IoGitNetworkOutline,
  IoShieldCheckmarkOutline,
  IoPulseOutline
} from "react-icons/io5";
import { FaKitMedical, FaCalendar, FaUser } from "react-icons/fa6";
import { MdLocationCity } from "react-icons/md";

export default function HomeBanner2() {
  const appContext = useContext(AppContext);

  return (
    <>
      
      <section className="dept-section">
        <div className="dept-container">
          
          <div className="dept-top-bar">
            <div 
              className="dept-loc"
            >
              
              <a 
                href={`https://maps.app.goo.gl/F54E4TFQy9iWrmXJ6`} 
                target="_blank" 
                rel="noreferrer" 
              >
                <IoLocationOutline size={18} color="var(--medical-teal)" />
                Nanguba Health — Dodoma, Tanzania <br/>
                
              </a>
            </div>

            <div className="btn-group-nav">
              <a href={hospitalInfo.patientUrl} target="_blank" rel="noreferrer" className="btn-medical">
                <FaKitMedical size={15}/> Patient Portal
              </a>
              <a href={hospitalInfo.staffUrl} target="_blank" rel="noreferrer" className="btn-medical">
                <FaUser size={14}/> Staff Portal
              </a>
              <a href={hospitalInfo.scheduleUrl} target="_blank" rel="noreferrer" className="btn-medical btn-accent">
                <FaCalendar size={14}/> Schedule An Appointment
              </a>
            </div>
          </div>

          <div className="strategic-tiers">
            <div className="tier-item">
              <div className="tier-icon-wrapper">
                <IoGitNetworkOutline size={22} />
              </div>
              <div>
                <span className="tier-tag">Structure</span>
                <div className="tier-title">3-Tier Integrated Network</div>
              </div>
            </div>
            
            <div className="tier-item">
              <div className="tier-icon-wrapper">
                <IoShieldCheckmarkOutline size={22} />
              </div>
              <div>
                <span className="tier-tag">Governance</span>
                <div className="tier-title">Ethical & Evidence-Based</div>
              </div>
            </div>

            <div className="tier-item">
              <div className="tier-icon-wrapper">
                <IoPulseOutline size={22} />
              </div>
              <div>
                <span className="tier-tag">Digital</span>
                <div className="tier-title">100% Digital Integration</div>
              </div>
            </div>
          </div>

        </div>
      </section>
    </>
  );
}